import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {setLanguage} from "../../features/langSlice";
import { normalizeLanguageCode } from "../../utils/language";

const EmptyHeader = () => {
    const [selected] = useState(normalizeLanguageCode(localStorage.getItem('lang')));
    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(setLanguage({lng:selected}))

    }, [selected]);

}

export default EmptyHeader;
